module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./theme.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/theme.md
// module id = aLHV
// module chunks = 0